import queryString from "query-string";

export const parseQueryString = (options = []) => {
  return queryString.parse(
    window.location.search,
    {
      arrayFormat: "comma",
      parseNumbers: true,
      ...options,
    }
  );
};

export const applyQueryString = (params, options = []) => {
  const stringifiedQueryString = queryString.stringify(params, {
    arrayFormat: "comma",
    encode: false,
    ...options,
  });

  const { protocol, host, pathname } = window.location;
  const url = [
    protocol,
    "//",
    host,
    pathname,
    stringifiedQueryString && "?" + stringifiedQueryString,
  ].join("");

  window.history.pushState({}, "", url);
};
